import { Component, OnInit } from '@angular/core';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { App } from 'src/app/models/app';
import { ApplicationHubService } from 'src/app/services/application-hub.service';

@Component({
  selector: 'app-app-add',
  templateUrl: './app-add.component.html',
  styleUrls: ['./app-add.component.scss']
})
export class AppAddComponent implements OnInit {

  App: App = {
    Active: false,
    Production: false,
    RoleRequired: false
  };

  success: boolean | undefined;

  constructor(private service: ApplicationHubService) { }

  ngOnInit(): void {

  }

  create(): void {

    this.service.post(this.App).subscribe(response => {
      console.log('Response from .NET:', response);
      this.success = true;
    }, error => {
      console.error('Error:', error);
      this.success = false;
    });
  }
}
